var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3629",
    x: 0.6,
    y: 1.6,
    width: 14.8,
    height: 12.8,
    rx: 1.4,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 129",
    cx: 5,
    cy: 7,
    r: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 7",
    d: "M10.1111 8.48109C10.3113 8.2335 10.6887 8.2335 10.8889 8.48109L12.8729 10.9357C13.1372 11.2627 12.9045 11.75 12.484 11.75H8.51597C8.09554 11.75 7.86282 11.2627 8.12711 10.9357L10.1111 8.48109Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIcon);
export default __webpack_public_path__ + "static/media/background-icon.e3c0e766.svg";
export { ForwardRef as ReactComponent };